import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useAuth } from '../store/AuthContext';
import EmailProviderSettings from '../components/admin/EmailProviderSettings';
import PageHeroHeader from '../components/ui/PageHeroHeader';
import styles from './AdminPage.module.css';

const EmailProvidersPage = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const isSuperadmin = user?.role === 'superadmin';

    useEffect(() => {
        if (!isSuperadmin) {
            navigate('/dashboard', { replace: true });
        }
    }, [isSuperadmin, navigate]);

    if (!isSuperadmin) return null;

    return (
        <div className={styles.page}>
            <PageHeroHeader
                icon={Shield}
                title="Email providers"
                subtitle="Control which email domains can create accounts. This helps block disposable emails and keep access limited to trusted organizations."
                actions={<div className={styles.quickStat}><div className={styles.quickStatIcon} style={{ background: 'var(--primary-50)', color: 'var(--primary-700)' }}><Shield size={18} /></div><div><div className={styles.quickStatValue}>Superadmin only</div><div className={styles.quickStatLabel}>Security setting</div></div></div>}
            />

            <EmailProviderSettings />
        </div>
    );
};

export default EmailProvidersPage;

